import {Link, Outlet} from "react-router-dom";

function Layout() {
  return (
    <>
      <Outlet />

      <div className="gdrpaBar">
        <Link to="/">Main</Link>
        <Link to="/privacy-policy">Privacy policy</Link>
        <Link to="/terms">Terms of use</Link>
      </div>
    </>
  );
}

export default Layout;
